export default "__VITE_ASSET__D$NjU8a2__"